/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) {
        return;
    }

    const burger = navigation.querySelector('.gh-burger');
    const menu = navigation.querySelector('.gh-navigation-menu');

    if (!burger || !menu) {
        return;
    }

    const closeMenu = function () {
        navigation.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflowY = null;
    };

    const openMenu = function () {
        navigation.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflowY = 'hidden';
    };

    burger.addEventListener('click', function () {
        if (navigation.classList.contains('is-open')) {
            closeMenu();
            return;
        }

        openMenu();
    });

    menu.querySelectorAll('a, button').forEach(function (item) {
        item.addEventListener('click', function () {
            closeMenu();
        });
    });

    window.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeMenu();
        }
    });

    window.addEventListener('resize', function () {
        if (window.innerWidth > 820) {
            closeMenu();
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Members overview tag filters */
(function () {
    const roots = document.querySelectorAll('[data-members-filter-root]');

    if (!roots.length) {
        return;
    }

    roots.forEach(function (root) {
        const controls = root.querySelector('[data-members-filter-controls]');
        const items = Array.from(root.querySelectorAll('[data-members-filter-item]'));
        const emptyState = root.querySelector('[data-members-empty-state]');

        if (!controls || !items.length) {
            return;
        }

        const tags = new Map();

        items.forEach(function (item) {
            const tagNodes = item.querySelectorAll('[data-tag-slug]');
            const itemTags = [];

            tagNodes.forEach(function (tagNode) {
                const slug = tagNode.dataset.tagSlug;
                const name = tagNode.dataset.tagName || slug;

                if (!slug) {
                    return;
                }

                itemTags.push(slug);

                if (!tags.has(slug)) {
                    tags.set(slug, name);
                }
            });

            item.dataset.filterTags = itemTags.join(' ');
        });

        tags.forEach(function (name, slug) {
            const button = document.createElement('button');
            button.className = 'hh-members-filter';
            button.type = 'button';
            button.dataset.filter = slug;
            button.textContent = name;
            button.setAttribute('aria-pressed', 'false');
            controls.appendChild(button);
        });

        const update = function (selectedFilter) {
            let visibleCount = 0;

            controls.querySelectorAll('[data-filter]').forEach(function (button) {
                const isActive = button.dataset.filter === selectedFilter;
                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });

            items.forEach(function (item) {
                const tagsForItem = item.dataset.filterTags || '';
                const matches = selectedFilter === 'all' || tagsForItem.split(' ').includes(selectedFilter);
                item.classList.toggle('is-hidden', !matches);

                if (matches) {
                    visibleCount += 1;
                }
            });

            if (emptyState) {
                emptyState.classList.toggle('is-hidden', visibleCount > 0);
            }
        };

        controls.addEventListener('click', function (event) {
            const button = event.target.closest('[data-filter]');

            if (!button) {
                return;
            }

            update(button.dataset.filter);
        });

        update('all');
    });
})();
